<div class="illustration" [class.cover]="cover" (click)="openLightboxImage($event)" [style.background-image]="'url(\''+thumbSrc+'\')'" [style.padding-bottom]="100*(height/width)+'%'"></div>
